module.exports = __webpack_public_path__ + "img/new_xiaohongshu.47151eb1.png";